import styled from 'styled-components';

export const StyledMightyFuSection = styled.div`
  background: url('https://media-staging.appcharge.com/media/672a38416f23aa263f8b1947/1730880057380__fb0c6e0b-c4ed-40ba-af0c-79a29a88cc88')
    center;
  background-size: cover;
  margin-top: 8px;
  margin-bottom: 5px;
  width: 300px;
  height: 61px;
  display: flex;
  align-items: center;
  justify-content: center;

  .section-text {
    font-size: 16px;
  }

  .section-image {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    .image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .section-name {
    max-width: 185px;
    font-family: 'Lemon Milk';
    margin: 0 6px;
    color: #c3e4fb;
    text-shadow: -1px -1px 0 #0c475c, 1px -1px 0 #0c475c, -1px 1px 0 #0c475c,
      1px 1px 0 #0c475c;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    text-transform: uppercase;
  }
` as any;
